import { render, staticRenderFns } from "./TiptapFooter.vue?vue&type=template&id=ecff101c"
import script from "./TiptapFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./TiptapFooter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports